import React from 'react';
import { Github, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

function FooterComponent() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer" style={{
      padding: '2rem 0',
      marginTop: 'auto',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      backgroundColor: 'var(--background-card)',
      textAlign: 'center'
    }}>
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', marginBottom: '1.5rem' }}>
          <a href="https://github.com/mileschildress88" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-secondary)' }}>
            <Github size={24} />
          </a>
          <a href="https://www.linkedin.com/in/jmiles-childress" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-secondary)' }}>
            <Linkedin size={24} />
          </a>
        </div>
        
        <div style={{ marginBottom: '1rem' }}>
          <Link to="/" style={{ margin: '0 1rem', color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '0.9rem' }}>Home</Link>
          <Link to="/about" style={{ margin: '0 1rem', color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '0.9rem' }}>About</Link>
          <Link to="/portfolio" style={{ margin: '0 1rem', color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '0.9rem' }}>Portfolio</Link>
          <Link to="/contact" style={{ margin: '0 1rem', color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '0.9rem' }}>Contact</Link>
        </div>

        <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: 0 }}>
            {currentYear} Miles Childress
        </p>
      </div>
    </footer>
  );
}

export default FooterComponent;
